"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const native_stack_1 = require("@react-navigation/native-stack");
const native_1 = require("@react-navigation/native");
const useAppSelector_1 = __importDefault(require("../hooks/useAppSelector"));
const analytics_1 = require("../utils/analytics");
const linking_1 = __importDefault(require("./linking"));
const home_1 = __importDefault(require("../features/home/home"));
const search_1 = __importDefault(require("../features/search/search"));
const authSignIn_1 = __importDefault(require("../features/auth/authSignIn"));
const profile_1 = __importDefault(require("../features/profile/profile"));
const qualityAsssurance_1 = __importDefault(require("../features/qualityAssurance/qualityAsssurance"));
const screenConstants_1 = require("../constants/screenConstants");
const typesConstants_1 = require("../constants/typesConstants");
const scheduleSearchedComponent_1 = __importDefault(require("../features/search/scheduleSearchedComponent"));
const previousSchedules_1 = __importDefault(require("../features/schedules/previousSchedules"));
const officersMetrics_1 = __importDefault(require("../features/officer/officersMetrics"));
const officerSchedules_1 = __importDefault(require("../features/schedules/officerSchedules"));
const audit_1 = __importDefault(require("../features/qualityAssurance/audit"));
const auditedCallDetailRecord_1 = __importDefault(require("../features/qualityAssurance/auditedCallDetailRecord"));
const ticket_1 = __importDefault(require("../features/ticket/ticket"));
const campaign_1 = __importDefault(require("../features/campaign/campaign"));
const ticketDetails_1 = __importDefault(require("../components/ticketComponent/ticketDetails"));
const campaigns_1 = __importDefault(require("../features/campaign/campaigns"));
const campaignsMetrics_1 = __importDefault(require("../features/campaign/campaignsMetrics"));
const notifications_1 = __importDefault(require("../features/notifications/notifications"));
const manualConfirmation_1 = __importDefault(require("../features/schedules/manualConfirmation"));
const topUserEngagement_1 = __importDefault(require("../features/schedules/topUserEngagement"));
const scheduleActions_1 = __importDefault(require("../features/actions/scheduleActions"));
const Stack = native_stack_1.createNativeStackNavigator();
const MainStackNavigator = () => {
    const { isLoggedIn, user } = useAppSelector_1.default((state) => ({
        isLoggedIn: state.auth.token,
        user: state.auth.user,
    }));
    const navigationRef = native_1.useNavigationContainerRef();
    const routeNameRef = react_1.useRef(); // nosemgrep: typescript.react.security.audit.react-no-refs.react-no-refs
    return (react_1.default.createElement(native_1.NavigationContainer // nosemgrep: typescript.react.security.audit.react-no-refs.react-no-refs
    , { ref: navigationRef, linking: linking_1.default, onReady: () => {
            routeNameRef.current = navigationRef.getCurrentRoute().name;
            analytics_1.trackScreenView(null, navigationRef.getCurrentRoute().name);
        }, onStateChange: () => {
            const previousRouteName = routeNameRef.current;
            const currentRouteName = navigationRef.getCurrentRoute().name;
            if (previousRouteName !== currentRouteName) {
                analytics_1.trackScreenView(previousRouteName, currentRouteName);
            }
            // Update the current route name with the new route
            routeNameRef.current = currentRouteName;
        } },
        react_1.default.createElement(Stack.Navigator, null, isLoggedIn && !!user ? (
        // screens for logged in users
        react_1.default.createElement(Stack.Group, null,
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.DASHBOARD_SCREEN, component: home_1.default, options: { headerShown: false, title: 'Call Center' } }),
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.PROFILE_SCREEN, component: profile_1.default, options: { headerShown: false, title: 'Call Center - Profile' } }),
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.PREVIOUS_SCHEDULES_SCREEN, component: previousSchedules_1.default, options: { headerShown: false, title: 'Call Center - Previous Schedules' } }),
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.SCHEDULE_SCREEN, component: scheduleSearchedComponent_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Schedule',
                } }),
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.AUDITED_CDR_SCREEN, component: auditedCallDetailRecord_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Audited Call Record Detail',
                } }),
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.TICKET_SCREEN, component: ticket_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Tickets',
                } }),
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.NOTIFICATIONS_SCREEN, component: notifications_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Notifications',
                } }),
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.TICKET_DETAIL_SCREEN, component: ticketDetails_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Ticket Detail',
                } }),
            user.scheduling_type === typesConstants_1.SCHEDULING_TYPE_AUTOMATED && (react_1.default.createElement(Stack.Screen, { name: screenConstants_1.CAMPAIGN_SCREEN, component: campaign_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Campaign',
                } })),
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.SEARCH_SCREEN, component: search_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Search Schedule',
                } }),
            user.is_manager && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Stack.Screen, { name: screenConstants_1.OFFICERS_METRICS_SCREEN, component: officersMetrics_1.default, options: {
                        headerShown: false,
                        title: 'Call Center - Officers Metrics',
                    } }),
                react_1.default.createElement(Stack.Screen, { name: screenConstants_1.CAMPAIGNS_SCREEN, component: campaigns_1.default, options: {
                        headerShown: false,
                        title: 'Call Center - Campaigns',
                    } }),
                react_1.default.createElement(Stack.Screen, { name: screenConstants_1.CAMPAIGNS_METRICS_SCREEN, component: campaignsMetrics_1.default, options: {
                        headerShown: false,
                        title: 'Call Center - Campaign Metrics',
                    } }),
                react_1.default.createElement(Stack.Screen, { name: screenConstants_1.OFFICER_SCHEDULES_SCREEN, component: officerSchedules_1.default, options: {
                        headerShown: false,
                        title: "Call Center - Officers' Schedules",
                    } }))),
            user.officer_type === typesConstants_1.OFFICER_TYPES_QUALITY_ANALYST && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Stack.Screen, { name: screenConstants_1.QUALITY_ASSURANCE_SCREEN, component: qualityAsssurance_1.default, options: {
                        headerShown: false,
                        title: 'Call Center - Quality Assurance',
                    } }),
                react_1.default.createElement(Stack.Screen, { name: screenConstants_1.AUDIT_SCREEN, component: audit_1.default, options: {
                        headerShown: false,
                        title: 'Call Center - Audit Call Record',
                    } }),
                react_1.default.createElement(Stack.Screen, { name: screenConstants_1.SCHEDULE_ACTIONS_SCREEN, component: scheduleActions_1.default, options: {
                        headerShown: false,
                        title: 'Call Center - Schedule Actions',
                    } }))),
            (user.officer_type === typesConstants_1.OFFICER_TYPES_MANUAL_CONFIRMATION || user.is_manager) && (react_1.default.createElement(Stack.Screen, { name: screenConstants_1.MANUAL_CONFIRMATION_SCREEN, component: manualConfirmation_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Manual Confirmation',
                } })),
            (user.officer_type === typesConstants_1.OFFICER_TYPES_KEY_ACCOUNT || user.is_manager) && (react_1.default.createElement(Stack.Screen, { name: screenConstants_1.TOP_USER_ENGAGEMENT_SCREEN, component: topUserEngagement_1.default, options: {
                    headerShown: false,
                    title: 'Call Center - Top User Engagement',
                } })))) : (
        // screens for not logged in users (
        react_1.default.createElement(Stack.Group, null,
            react_1.default.createElement(Stack.Screen, { name: screenConstants_1.SIGNIN_SCREEN, component: authSignIn_1.default, options: { headerShown: false, title: 'Call Center - Sign in' } }))))));
};
exports.default = MainStackNavigator;
